import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const Footer = () => {
  const { c } = useContent();
  return (
  <footer className="bg-slate-950 text-slate-300" data-testid="footer">
    <div className="h-1" style={{ background: "linear-gradient(90deg, var(--tp), var(--tp-l), var(--ta))" }} />
    <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <div className="flex items-center gap-3 mb-4">
          <img src="/logo-bpbd.png" alt="Logo BPBD" className="w-11 h-11 object-contain" />
          <div>
            <p className="font-heading font-bold text-white">BPBD</p>
            <p className="text-xs text-slate-400">Kab. Kayong Utara</p>
          </div>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Badan Penanggulangan Bencana Daerah Kabupaten Kayong Utara, Kalimantan Barat.
        </p>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Navigasi</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/profil" className="hover:text-orange-400 transition-colors">Profil BPBD</Link></li>
          <li><Link to="/bidang" className="hover:text-orange-400 transition-colors">Bidang Penanggulangan</Link></li>
          <li><Link to="/informasi" className="hover:text-orange-400 transition-colors">Informasi Kebencanaan</Link></li>
          <li><Link to="/informasi-publik" className="hover:text-orange-400 transition-colors">PPID & Dokumen</Link></li>
          <li><Link to="/layanan" className="hover:text-orange-400 transition-colors">Lapor Bencana</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Tautan Terkait</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="https://bnpb.go.id" target="_blank" rel="noreferrer" className="hover:text-orange-400 transition-colors">BNPB</a></li>
          <li><a href="https://bmkg.go.id" target="_blank" rel="noreferrer" className="hover:text-orange-400 transition-colors">BMKG</a></li>
          <li><a href="https://vsi.esdm.go.id" target="_blank" rel="noreferrer" className="hover:text-orange-400 transition-colors">Badan Geologi</a></li>
          <li><a href="https://kayongutarakab.go.id" target="_blank" rel="noreferrer" className="hover:text-orange-400 transition-colors">Pemkab Kayong Utara</a></li>
          <li><Link to="/tautan" className="hover:text-orange-400 transition-colors">Semua Tautan</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Kontak</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex gap-2"><MapPin size={16} className="text-orange-500 shrink-0 mt-0.5" /> {c("kontak_alamat", "Jl. Bhayangkara, Sukadana, Kabupaten Kayong Utara, Kalimantan Barat")}</li>
          <li className="flex gap-2"><Phone size={16} className="text-orange-500 shrink-0" /> Call Center {c("kontak_darurat", "112")} (24 Jam) · {c("kontak_telepon", "(0534) 771-112")}</li>
          <li className="flex gap-2"><Mail size={16} className="text-orange-500 shrink-0" /> {c("kontak_email", "bpbd@kayongutarakab.go.id")}</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
        <p>© 2026 BPBD Kabupaten Kayong Utara. Hak cipta dilindungi.</p>
        <p>Syarat & Ketentuan · Kebijakan Privasi</p>
      </div>
    </div>
  </footer>
  );
};
